exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.carousel-3d-container { margin:20px auto 0 auto !important;\n}\n.carousel-3d-container figure { margin:0;\n}\n.carousel-3d-container figcaption {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  bottom: 0;\n  position: absolute;\n  bottom: 0;\n  padding: 15px;\n  font-size: 12px;\n  min-width: 100%;\n  box-sizing: border-box;\n}\n", ""]);

// exports
